export interface SkeletonLineProps {
  className?: string;
  'data-hook'?: string;
}
